export default "__VITE_ASSET__JQJf8fR8__"